'use client'

import generateClassNames from '@/utils/generate-class-names'
import clsx from 'clsx'
import mergeRefs from 'merge-refs'
import React, { forwardRef, useContext } from 'react'
import { TabsContext } from '../tabs-context'
import './tab.scss'

const classes = generateClassNames('tab', [])

export interface TabProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  value: string
}

export const Tab = forwardRef(function Tab(
  props: TabProps,
  ref: React.ForwardedRef<HTMLButtonElement>
) {
  const { children, className, value, ...other } = props

  const {
    getTabId,
    getTabPanelId,
    onValueChange,
    tabRefs,
    value: contextValue,
    variant,
  } = useContext(TabsContext)

  const handleClick = () => {
    onValueChange(value)
  }

  const isActive = value === contextValue

  const handleRef = (node: HTMLButtonElement | null) => {
    tabRefs.current[value] = node
  }

  return (
    <button
      ref={mergeRefs(handleRef, ref)}
      type='button'
      role='tab'
      id={getTabId(value)}
      aria-controls={getTabPanelId(value)}
      aria-selected={isActive}
      className={clsx(classes.root, `${classes.root}--${variant}`, className)}
      data-status={isActive ? 'active' : 'inactive'}
      tabIndex={isActive ? 0 : -1}
      onClick={handleClick}
      {...other}
    >
      {children}
    </button>
  )
})
